document.addEventListener("DOMContentLoaded", function () {
  const initMJProduct = () => {
    const sectionElement = document.querySelector("[data-section]");
    if (!sectionElement) return;
    const sectionId = sectionElement.dataset.section;
    const qtyButtons = document.querySelectorAll(".mj-qty-btn");
    const planOptions = document.querySelectorAll(".mj-plan-option");
    const frequencySelect = document.querySelector(".mj-frequency-select");
    const planWrapper = document.querySelector(".mj-selling-plan-wrapper");

    // Gallery Logic
    const mainImage = document.getElementById(`MJMainImage-${sectionId}`);
    const thumbnails = document.querySelectorAll(".mj-thumbnail");
    const thumbWrapper = document.querySelector(".mj-thumbnails-wrapper");
    const prevBtn = document.querySelector(".mj-thumb-prev");
    const nextBtn = document.querySelector(".mj-thumb-next");

    const switchMainImage = (url) => {
      if (!mainImage) return;
      mainImage.style.opacity = "0";
      setTimeout(() => {
        mainImage.src = url;
        mainImage.style.opacity = "1";
      }, 150);
    };

    thumbnails.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        thumbnails.forEach((t) => t.classList.remove("active"));
        this.classList.add("active");
        switchMainImage(this.dataset.imageUrl);

        // Scroll into view if needed
        this.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        });
      });
    });

    // Arrow Logic
    if (prevBtn && nextBtn && thumbWrapper) {
      prevBtn.addEventListener("click", () => {
        thumbWrapper.scrollBy({ left: -200, behavior: "smooth" });
      });
      nextBtn.addEventListener("click", () => {
        thumbWrapper.scrollBy({ left: 200, behavior: "smooth" });
      });
    }

    // Variant change listener for images
    const handleVariantChange = (id) => {
      const variantThumb = document.querySelector(
        `.mj-thumbnail[data-variant-id="${id}"]`,
      );
      if (!variantThumb) return;

      // Update active state and main image directly (don't use .click() to avoid recursion)
      thumbnails.forEach((t) => t.classList.remove("active"));
      variantThumb.classList.add("active");
      switchMainImage(variantThumb.dataset.imageUrl);

      // Scroll the wrapper to center the active thumbnail
      if (thumbWrapper) {
        const scrollTarget =
          variantThumb.offsetLeft -
          thumbWrapper.offsetWidth / 2 +
          variantThumb.offsetWidth / 2;
        thumbWrapper.scrollTo({ left: scrollTarget, behavior: "smooth" });
      }
    };

    // Use Dawn's pub/sub system for reliable variant change detection.
    // No sectionId filter — product-info.js may publish with data-original-section
    // instead of data-section, causing a mismatch. The querySelector above is already
    // scoped to this section's DOM so there's no risk of cross-section interference.
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const { variant } = event.data;
        if (variant) handleVariantChange(String(variant.id));
      });
    }

    // Fallback: also listen for the change event on the hidden variant input
    const productInfo = document.querySelector("product-info");
    if (productInfo) {
      productInfo.addEventListener("change", (event) => {
        if (event.target.name === "id" && event.target.value) {
          handleVariantChange(event.target.value);
        }
      });
    }

    // Money formatting helper
    const formatMoney = (cents) => {
      // In a production theme, you might use Shopify.formatMoney
      // Here we assume USD for simplicity or provide a basic formatter
      const dollars = cents / 100;
      return `$${dollars.toFixed(2)}`;
    };

    const updatePrices = (qty, servings, qtyIndex) => {
      if (!planWrapper) return;
      const oneTimeVal = planWrapper.querySelector(
        ".mj-one-time .mj-plan-price-val",
      );
      const subscribeVal = planWrapper.querySelector(
        ".mj-subscribe .mj-plan-price-val",
      );

      const oneTimePrice =
        planWrapper.getAttribute(`data-one-time-price${qtyIndex}`) || "";
      const subscribePrice =
        planWrapper.getAttribute(`data-subscribe-price${qtyIndex}`) || "";

      if (oneTimeVal) oneTimeVal.textContent = oneTimePrice;
      if (subscribeVal) subscribeVal.textContent = subscribePrice;

      const subscribeDayVal =
        planWrapper.getAttribute(`data-subscribe-day-val${qtyIndex}`) || "";
      const oneTimeDayVal =
        planWrapper.getAttribute(`data-one-time-day-val${qtyIndex}`) || "";
      const subscribeDayPrefix =
        planWrapper.getAttribute(`data-subscribe-day-prefix${qtyIndex}`) || "";
      const oneTimeDayPrefix =
        planWrapper.getAttribute(`data-one-time-day-prefix${qtyIndex}`) || "";

      const subscribePricePerDay = planWrapper.querySelector(".mj-subscribe .mj-price-per-day");
      const oneTimePricePerDay = planWrapper.querySelector(".mj-one-time .mj-price-per-day");

      if (subscribePricePerDay) {
        const labelEl = subscribePricePerDay.querySelector(".mj-price-day-label");
        const valEl = subscribePricePerDay.querySelector(".mj-price-day-val");
        if (labelEl) labelEl.textContent = subscribeDayPrefix;
        if (valEl) valEl.textContent = subscribeDayVal;
        subscribePricePerDay.style.display = subscribeDayVal ? "block" : "none";
      }

      if (oneTimePricePerDay) {
        const labelEl = oneTimePricePerDay.querySelector(".mj-price-day-label");
        const valEl = oneTimePricePerDay.querySelector(".mj-price-day-val");
        if (labelEl) labelEl.textContent = oneTimeDayPrefix;
        if (valEl) valEl.textContent = oneTimeDayVal;
        oneTimePricePerDay.style.display = oneTimeDayVal ? "block" : "none";
      }
    };

    // Find the hidden inputs in the main product form
    const findFormInputs = (sectionId) => {
      const form = document.getElementById(`product-form-${sectionId}`);
      if (!form) return null;
      return {
        qtyInput:
          form.querySelector('input[name="quantity"]') ||
          document.querySelector(
            `input[name="quantity"][form="product-form-${sectionId}"]`,
          ),
        planInput:
          form.querySelector('input[name="selling_plan"]') ||
          document.querySelector(
            `input[name="selling_plan"][form="product-form-${sectionId}"]`,
          ),
        bundleInput:
          form.querySelector('input[name="properties[Bundle]"]') ||
          document.querySelector(
            `input[name="properties[Bundle]"][form="product-form-${sectionId}"]`,
          ),
      };
    };

    // Initial price update
    const initialActiveQty = document.querySelector(".mj-qty-btn.active");
    if (initialActiveQty) {
      updatePrices(
        parseInt(initialActiveQty.dataset.value),
        parseInt(initialActiveQty.dataset.servings),
        initialActiveQty.dataset.qtyIndex,
      );
    }

    // Set selling_plan on load if subscription is the default active option
    const initialActiveOption = document.querySelector(".mj-plan-option.active");
    if (initialActiveOption && initialActiveOption.dataset.planType === "subscription") {
      const initSectionId = sectionId;
      const initInputs = findFormInputs(initSectionId);
      if (initInputs && initInputs.planInput) {
        initInputs.planInput.value = frequencySelect ? frequencySelect.value : "";
        initInputs.planInput.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    // Quantity buttons click handler
    qtyButtons.forEach((btn) => {
      btn.addEventListener("click", function () {
        const sectionId = this.closest("[data-section]").dataset.section;
        const inputs = findFormInputs(sectionId);
        const qty = parseInt(this.dataset.value);
        const servings = parseInt(this.dataset.servings);
        const qtyIndex = this.dataset.qtyIndex;
        const label = this.dataset.label;

        qtyButtons.forEach((b) => b.classList.remove("active"));
        this.classList.add("active");

        updatePrices(qty, servings, qtyIndex);

        if (inputs) {
          if (inputs.qtyInput) {
            inputs.qtyInput.value = qty;
            inputs.qtyInput.dispatchEvent(
              new Event("change", { bubbles: true }),
            );
          }
          if (inputs.bundleInput) {
            inputs.bundleInput.value = label;
          }
        }
      });
    });

    // Plan selection handler
    planOptions.forEach((option) => {
      option.addEventListener("click", function (e) {
        if (e.target.tagName === "SELECT") return;

        const sectionId = this.closest("[data-section]").dataset.section;
        const inputs = findFormInputs(sectionId);
        const radio = this.querySelector('input[type="radio"]');

        planOptions.forEach((opt) => opt.classList.remove("active"));
        this.classList.add("active");
        if (radio) radio.checked = true;

        if (inputs && inputs.planInput) {
          if (this.dataset.planType === "subscription") {
            inputs.planInput.value = frequencySelect
              ? frequencySelect.value
              : "";
          } else {
            // Clear every selling_plan input in or associated with the form
            const formEl = document.getElementById(`product-form-${sectionId}`);
            if (formEl) {
              formEl.querySelectorAll('input[name="selling_plan"]').forEach(el => { el.value = ""; });
            }
            document.querySelectorAll(`input[name="selling_plan"][form="product-form-${sectionId}"]`).forEach(el => { el.value = ""; });
            inputs.planInput.value = "";
          }
          inputs.planInput.dispatchEvent(
            new Event("change", { bubbles: true }),
          );
        }
      });
    });

    // Frequency select change handler
    if (frequencySelect) {
      frequencySelect.addEventListener("change", function () {
        const sectionId = this.closest("[data-section]").dataset.section;
        const inputs = findFormInputs(sectionId);
        const subscribeOption = document.querySelector(
          '.mj-plan-option[data-plan-type="subscription"]',
        );

        if (subscribeOption && subscribeOption.classList.contains("active")) {
          if (inputs && inputs.planInput) {
            inputs.planInput.value = this.value;
            inputs.planInput.dispatchEvent(
              new Event("change", { bubbles: true }),
            );
          }
        }
      });
    }
  };

  initMJProduct();
  document.addEventListener("shopify:section:load", initMJProduct);
});
